import { useTranslation } from 'react-i18next';

import React from 'react';

import { useEventPreviewContext } from 'components/Contexts/EventPreview/EventPreviewContext';
import Opacity from 'components/Opacity/Opacity';

import EventCard from '../EventCard/EventCard';

const EventPreviewCard = () => {
  const { t } = useTranslation();

  const { imageUrl, altText, title, startTime, endTime, timezone } = useEventPreviewContext();

  const titlePlaceholder = t(
    'components-forms-weekly_check_in_placeholder',
    'eg. Weekly Check-in, Q&A...'
  );

  return (
    <Opacity value={0.6}>
      <EventCard
        endTime={endTime}
        imageAltText={altText}
        imageUrl={imageUrl}
        startTime={startTime}
        timezone={timezone || undefined}
        title={title || titlePlaceholder}
        isPreview
      />
    </Opacity>
  );
};

export default EventPreviewCard;
